var map = {
	"./bsc-index-top-10.png": 33338,
	"./bsc_index_top_10__equally_balanced.png": 93590,
	"./bsc_index_top_10__liquidity.png": 68878,
	"./bsc_index_top_10__market_cap.png": 59500,
	"./defi.png": 48571,
	"./defi__equally_balanced.png": 99976,
	"./defi__liquidity.png": 86262,
	"./defi__market_cap.png": 23891,
	"./governance.png": 93759,
	"./governance__equally_balanced.png": 41087,
	"./governance__liquidity.png": 83503,
	"./governance__market_cap.png": 41034,
	"./info_dark_grey.png": 12118,
	"./info_purple.png": 91656,
	"./metaverse.png": 57776,
	"./metaverse__equally_balanced.png": 36845,
	"./metaverse__liquidity.png": 59385,
	"./metaverse__market_cap.png": 18145,
	"./settings.png": 34476,
	"./success_tick.png": 8968,
	"./swap-switch.png": 17858,
	"./warning_large.png": 10497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16003;